/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { OasExternalDocumentation } from '../../models/OasExternalDocumentation';

/**
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OasExternalDocumentation
 */
export class Oas20ExternalDocumentation extends OasExternalDocumentation {
    constructor() {
        super();
    }
}
Oas20ExternalDocumentation["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20ExternalDocumentation";
Oas20ExternalDocumentation["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




